import { render, staticRenderFns } from "./houses.vue?vue&type=template&id=829f0d32&scoped=true&"
import script from "./houses.vue?vue&type=script&lang=js&"
export * from "./houses.vue?vue&type=script&lang=js&"
import style0 from "./houses.vue?vue&type=style&index=0&id=829f0d32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "829f0d32",
  null
  
)

export default component.exports